<template lang="html">
  <div class="home">
    <Contents></Contents>
  </div>
</template>

<script>
import Contents from "../components/TOP/contents/_index.vue";

export default {
  name: "home",
  components: {
    Contents
  }
};
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/Pages/Index.vue